/**
 * Created by Jerker Nord on 2021-12-30.
 */

import {Emitter} from "pixi-particles";
import {gsap} from "gsap";

export class ParticlesManager {

    private static _instance:ParticlesManager;
    private static _emitters:Emitter[];
    private static _elapsed:number;

    private constructor() {
        if(ParticlesManager._instance) {
            debugger;
            throw new Error("Error: ParticlesManager.constructor() - Instantiation failed: Singleton.");
        }

        ParticlesManager._instance = this;
        ParticlesManager._emitters = [];
        this.createMainLoop();
    }

    private createMainLoop():void {
        gsap.ticker.add(() => this.update());
    }

    private update():void {
        if(ParticlesManager._emitters.length === 0) {
            return;
        }

        let now:number = Date.now();
        ParticlesManager._emitters.forEach((emitter:Emitter) => {
            emitter.update((now - ParticlesManager._elapsed) * 0.001);
        });
        ParticlesManager._elapsed = now;
    }

    public static addEmitter(emitter:Emitter, start:boolean = true):void {
        if(!ParticlesManager._instance) {
            new ParticlesManager();
        }

        ParticlesManager._emitters.push(emitter);
        emitter.emit = start;
        ParticlesManager._elapsed = Date.now();
        ParticlesManager._instance.update();
    }

    public static removeEmitter(emitter:Emitter):boolean {
        if(!ParticlesManager._instance) {
            return false;
        }

        const index:number = ParticlesManager._emitters.indexOf(emitter);
        if(index === -1) {
            return false;
        }
        ParticlesManager._emitters.splice(index, 1);
        emitter.emit = false;
        emitter.destroy();
        ParticlesManager._elapsed = Date.now();
        ParticlesManager._instance.update();
        return true;
    }
}